// extracted by mini-css-extract-plugin
export default {"button":"dcc_cartbox-button-button","iconWrapper":"dcc_cartbox-button-iconWrapper"};